import React, { useEffect, useState, useCallback } from "react";
import { apiClient } from "../../lib/api";
import { useI18n } from "../../lib/i18n";
import { ScrollText, Search } from "lucide-react";

export default function AuditTab() {
  const { lang } = useI18n();
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");

  const load = useCallback(() => {
    apiClient.get("/admin/audit-log", { params: { action: q || undefined } })
      .then(({ data }) => setItems(data.items || []));
  }, [q]);

  useEffect(() => { load(); }, [load]);

  return (
    <div data-testid="admin-audit" className="space-y-5">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <h2 className="font-display text-2xl flex items-center gap-2"><ScrollText className="w-5 h-5 text-[#8a6f2e]" /> {lang === "ar" ? "سجل النشاط" : "Audit log"} ({items.length})</h2>
        <div className="relative">
          <Search className="absolute top-1/2 -translate-y-1/2 start-3 w-4 h-4 text-[#8a8a8a]" />
          <input className="input-dark ps-9" placeholder={lang === "ar" ? "بحث بالإجراء..." : "Filter by action..."} value={q} onChange={(e) => setQ(e.target.value)} data-testid="audit-search" />
        </div>
      </div>
      <div className="surface rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#0a0a0a]/[0.04] text-[#3a3a3a] text-xs uppercase tracking-widest">
            <tr>
              <th className="p-3 text-start">{lang === "ar" ? "الوقت" : "Time"}</th>
              <th className="p-3 text-start">{lang === "ar" ? "المسؤول" : "Actor"}</th>
              <th className="p-3 text-start">{lang === "ar" ? "الإجراء" : "Action"}</th>
              <th className="p-3 text-start">{lang === "ar" ? "الهدف" : "Target"}</th>
              <th className="p-3 text-start">IP</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 ? (
              <tr><td colSpan="5" className="p-12 text-center text-[#6b6b6b]">{lang === "ar" ? "لا أحداث بعد." : "No events yet."}</td></tr>
            ) : items.map(e => (
              <tr key={e.id} className="border-t border-[#0a0a0a]/[0.06]" data-testid={`audit-${e.id}`}>
                <td className="p-3 text-[#3a3a3a] text-xs">{new Date(e.created_at).toLocaleString()}</td>
                <td className="p-3"><div className="text-sm">{e.actor_name || "-"}</div><div className="text-xs text-[#8a8a8a]">{e.actor_email}</div></td>
                <td className="p-3"><span className="pill text-[10px]">{e.action}</span></td>
                <td className="p-3 text-xs font-mono text-[#3a3a3a]">{(e.target || "").slice(0, 12)}</td>
                <td className="p-3 text-xs text-[#8a8a8a]">{e.ip || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
